import { render, staticRenderFns } from "./GizlilikSozlesmesi.vue?vue&type=template&id=b5cec4a6&"
import script from "./GizlilikSozlesmesi.vue?vue&type=script&lang=js&"
export * from "./GizlilikSozlesmesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports